import { render, staticRenderFns } from "./ToolTabs.vue?vue&type=template&id=04592f14&"
import script from "./ToolTabs.vue?vue&type=script&lang=js&"
export * from "./ToolTabs.vue?vue&type=script&lang=js&"
import style0 from "./ToolTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports